import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const FAVORITE_BUTTON_EXPERIMENT = 'aud_desktop_aud2718_fav_card';

export const selectIsFavoriteButtonExperimentActive = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);
  // эксперимент нацелен на группу = B
  const bGroup = isAbUseExperimentsActive(experiments, FAVORITE_BUTTON_EXPERIMENT, 'B');

  return bGroup;
};
